'use client';

import React, { useEffect, useRef } from 'react';

const stats = [
  { num: '500+', label: 'Members', sub: 'Across all tiers' },
  { num: '5', label: 'Years', sub: 'Of celebrations' },
  { num: '3', label: 'Iconic Themes', sub: 'Thakur Dalaan · Patachitra · Prathaa' },
  { num: '10,000+', label: 'Community Reach', sub: 'Footfall across 5 days (2025)' },
];

export default function CommunityStats() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => { entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('active'); }); },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-background alpona-bg w-full px-4 md:px-12 pt-12 md:pt-16 pb-12 md:pb-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12 reveal">
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-black text-foreground tracking-tight">
            The <span className="text-primary">HCAF Family</span>
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {stats?.map((s, i) => (
            <div
              key={s?.label}
              className="reveal bg-card border border-border rounded-2xl md:rounded-3xl p-5 md:p-7 text-center hover:shadow-gold hover:-translate-y-1 transition-all duration-300"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <p className="font-display text-3xl md:text-4xl lg:text-5xl font-black text-primary mb-1 md:mb-2">{s?.num}</p>
              <p className="font-bold text-foreground text-sm md:text-base mb-1">{s?.label}</p>
              <p className="text-muted-foreground text-xs leading-snug">{s?.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}